import React, { useEffect, useMemo } from 'react';

// helpers
import { useEntityIntakeFormContext } from './EntityIntakeFormContext';

// components
import IntakeForm from './IntakeForm';
import IntakeStatus from './IntakeStatus';
import LoadingWrapper from 'components/WrapperComponents/LoadingWrapper';

const EntityIntakeForm = () => {
  const { activeLayout, loadingIntakeForm, fetchAndStoreIntakeForm } =
    useEntityIntakeFormContext();

  useEffect(() => {
    fetchAndStoreIntakeForm();
  }, []);

  const content = useMemo(() => {
    if (!activeLayout) {
      return null;
    }
    switch (activeLayout) {
      case 'intake-form':
        return <IntakeForm />;

      case 'status':
        return <IntakeStatus />;
    }
  }, [activeLayout]);

  return (
    <LoadingWrapper loading={loadingIntakeForm || !activeLayout}>
      {content}
    </LoadingWrapper>
  );
};

export default EntityIntakeForm;
